import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { modelProfilesQueryKey } from "@/shared/domain/agentThread/hooks/useModelProfiles";

import type { OrgModelListResponse } from "../OrgLlmProviderRecord";

import { orgQueryKeys } from "./orgQueryKeys";

/**
 * Put an org back on the Roboto default models, keeping its connections.
 * Refreshes the same caches as {@link useUpdateOrgLlmProvider}.
 */
export function useResetOrgLlmProvider() {
  const { orgService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<OrgModelListResponse, Error, { orgId: string }>({
    mutationFn: ({ orgId }) => orgService.resetOrgLlmProvider(orgId),
    onSuccess: (response, { orgId }) => {
      queryClient.setQueryData(orgQueryKeys.llmProvider(orgId), response);
      void queryClient.invalidateQueries({
        queryKey: modelProfilesQueryKey(orgId),
      });
      void queryClient.invalidateQueries({
        queryKey: orgQueryKeys.modelConfigSearches(),
      });
    },
  });
}
